import React from "react";
import SanguoSandbox from "./game/SanguoSandbox.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";

export default function App() {
  return (
    <ErrorBoundary>
      <SanguoSandbox />
    </ErrorBoundary>
  );
}
